import * as yup from "yup";

const schema = yup.object().shape({
    Id: yup.number("Só é possível inserir números nesse campo"),
    Observacao: yup.string("Campo deve conter somente caracteres").required("Este campo é obrigatório"),
    DataConclusaoInstalacaoGD: yup.date().typeError("Valor inválido. Este campo é obrigatório").required("Valor inválido. Este campo é obrigatório"),
    SolicitacaoDeAcesso: yup.object().shape({
        value: yup.number().required(),
        label: yup.string()
    })
});

const defaultValues = {
    Id: 0,
    Observacao: " ",
    SolicitacaoDeAcesso: {
        value: "",
        label: ""
    },
}

export { schema, defaultValues }